import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-client',
  templateUrl: './no-client.component.html',
  styleUrls: ['./no-client.component.css']
})
export class NoClientComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
